<template>
  <el-dialog title="修改会员" :visible.sync="dialogVisible" width="70%" @close="handleClose">
    <el-form ref="form" :model="editShopVipUserInfo" label-width="120px">
      <el-form-item label="会员名称" prop="vipName" required>
        <el-input v-model="editShopVipUserInfo.vipName" placeholder="必填，请填写会员名称" style="width:100%" />
      </el-form-item>
      <el-form-item label="会员电话" prop="vipTel" required>
        <el-input v-model="editShopVipUserInfo.vipTel" placeholder="必填，请填写会员电话" style="width:100%" />
      </el-form-item>
      <el-form-item label="性别" prop="sex" required>
        <el-select v-model="editShopVipUserInfo.sex" placeholder="必填，请选择性别" style="width:100%">
          <el-option v-for="item in editShopVipUserInfo.sexs" :key="item.statusCd" :label="item.name"
            :value="item.statusCd" />
        </el-select>
      </el-form-item>
      <el-form-item label="会员等级" prop="vipLevel" required>
        <el-select v-model="editShopVipUserInfo.vipLevel" placeholder="必填，请选择会员等级" style="width:100%">
          <el-option v-for="item in editShopVipUserInfo.vipLevels" :key="item.vipLevelId" :label="item.levelName"
            :value="item.vipLevelId" />
        </el-select>
      </el-form-item>
      <el-form-item label="会员生日" prop="birthday" required>
        <el-date-picker v-model="editShopVipUserInfo.birthday" type="date" placeholder="必填，请填写会员生日"
          value-format="yyyy-MM-dd HH:mm:ss" style="width:100%" />
      </el-form-item>
      <el-form-item label="开始时间" prop="startTime" required>
        <el-date-picker v-model="editShopVipUserInfo.startTime" type="date" placeholder="必填，请填写开始时间"
          value-format="yyyy-MM-dd HH:mm:ss" style="width:100%" />
      </el-form-item>
      <el-form-item label="结束时间" prop="endTime" required>
        <el-date-picker v-model="editShopVipUserInfo.endTime" type="date" value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="必填，请填写结束时间" style="width:100%" />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" @click="editShopVipUser">保存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getShopId } from '@/api/shop/shopApi'
import { updateShopVipUser, queryShopVipLevel } from '@/api/user/shopVipUserApi'
import { getDict } from '@/api/shop/shopApi'

export default {
  name: 'EditShopVipUser',
  data() {
    return {
      dialogVisible: false,
      editShopVipUserInfo: {
        vipId: '',
        vipName: '',
        vipTel: '',
        sex: '',
        vipLevel: '',
        birthday: '',
        startTime: '',
        endTime: '',
        shopId: '',
        vipLevels: [],
        sexs: []
      }
    }
  },
  methods: {
    open(shopVipUser) {
      this.dialogVisible = true
      this.refreshEditShopVipUserInfo()
      Object.assign(this.editShopVipUserInfo, shopVipUser)
      this._listEditShopVipLevels()
      this.getSexDict()
    },
    handleClose() {
      this.$refs.form.resetFields()
      this.refreshEditShopVipUserInfo()
    },
    async getSexDict() {
      try {
        const { data } = await getDict('s_shop_vip_user', 'sex')
        this.editShopVipUserInfo.sexs = data
      } catch (error) {
        console.error('获取性别字典失败:', error)
      }
    },
    async editShopVipUser() {
      try {
        await this.$refs.form.validate()
        this.editShopVipUserInfo.shopId = getShopId()
        const res = await updateShopVipUser(this.editShopVipUserInfo)
        console.log(res)
        this.$message.success('修改成功')
        this.dialogVisible = false
        this.$emit('refresh')
      } catch (error) {
        this.$message.error(error)
        console.error('修改会员失败:', error)
      }
    },
    refreshEditShopVipUserInfo() {
      this.editShopVipUserInfo = {
        vipId: '',
        vipName: '',
        vipTel: '',
        sex: '',
        vipLevel: '',
        birthday: '',
        startTime: '',
        endTime: '',
        shopId: '',
        vipLevels: [],
        sexs: []
      }
    },
    async _listEditShopVipLevels() {
      const param = {
        page: 1,
        row: 50,
        shopId: getShopId()
      }
      try {
        const res = await queryShopVipLevel(param)
        this.editShopVipUserInfo.vipLevels = res.data
      } catch (error) {
        console.error('获取会员等级失败:', error)
      }
    }
  }
}
</script>